export const mdUp = () => window.innerWidth >= 768;
export const lgUp = () => window.innerWidth >= 992;
